import * as React from 'react';
import { useContext, useMemo, useEffect } from 'react';
import {
  Drawer,
  IconButton,
  ListItemButton,
  List,
  ListItem,
  ListItemText,
  Theme,
  Toolbar,
  useTheme,
  useMediaQuery,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

import { UIContext } from '../store/uiContext';

const LanguageDrawer: React.FC = () => {
  const { languageDrawerOpen, setLanguageDrawerOpen } = useContext(UIContext);
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));

  const Languages = useMemo(
    () => [
      {
        id: 'fi',
        name: t('finnish'),
      },
      {
        id: 'en',
        name: t('english'),
      },
    ],
    [t]
  );

  const drawerWidth = theme.languageDrawer?.width || 240;

  // On mount, set the language from localstorage
  useEffect(() => {
    const lsLang = localStorage.getItem('language');
    if (lsLang) {
      i18n.changeLanguage(lsLang);
    }
  }, [i18n]);

  return (
      <Drawer
          variant="temporary"
          open={languageDrawerOpen}
          anchor="right"
          onClose={() => setLanguageDrawerOpen(false)}
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: drawerWidth,
            },
          }}
          disablePortal
          slotProps={{
            backdrop: {
              invisible: true,
            },
          }}
          ModalProps={{
            style: {
              zIndex: theme.zIndex.drawer,
            },
          }}
      >
        <Toolbar />
        {isSmall && <Toolbar />}
        <Box sx={{ overflow: 'auto' }}>
          <List>
            <ListItem divider disableGutters sx={{ display: 'flex' }}>
              <IconButton
                  color="secondary"
                  sx={{ marginRight: theme.spacing(2) }}
                  onClick={() => setLanguageDrawerOpen(false)}
                  size="large"
              >
                <ArrowRightAltIcon />
              </IconButton>
              <ListItemText
                  primary={t('language')}
                  primaryTypographyProps={{
                    sx: {
                      fontSize: '1.1875rem',
                      fontWeight: theme.typography.fontWeightMedium,
                    },
                  }}
              />
            </ListItem>
            {Languages.map((lang) => (
                <ListItemButton
                    key={lang.id}
                    onClick={() => {
                      i18n.changeLanguage(lang.id);
                      localStorage.setItem('language', lang.id);
                      setLanguageDrawerOpen(false);
                    }}
                >
                  <ListItemText
                      primary={lang.name}
                      sx={
                        i18n.language === lang.id
                            ? { color: theme.palette.primary.main }
                            : {}
                      }
                  />
                </ListItemButton>
            ))}
          </List>
        </Box>
      </Drawer>
  );
};

export default LanguageDrawer;
